import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import SystemEditRoutes from './routes'

const SystemEdit = () => {
  const { systemId } = useNumericParams()

  useReduxAction(
    'systems',
    'loadSystem',
    {
      entityId: systemId,
    },
    [systemId],
    {
      dispatchAction: (action, requestOptions) => action(systemId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => systemId && !loading,
    },
  )

  return (
    <SystemEditRoutes />
  )
}

export default SystemEdit
